const customCursor = () => {
	const isWordPressEditor =
		document.body.classList.contains("wp-admin") ||
		document.body.classList.contains("block-editor-iframe__body") ||
		document.documentElement.classList.contains("block-editor-iframe__html");

	if (
		window.matchMedia("(hover: none)").matches ||
		window.matchMedia("(pointer: coarse)").matches ||
		isWordPressEditor
	) {
		return;
	}

	let cursor = document.querySelector(".custom-cursor");

	if (!cursor) {
		cursor = document.createElement("div");
		cursor.classList.add("custom-cursor");
		document.body.appendChild(cursor);
	}

	document.documentElement.classList.add("has-custom-cursor");

	let mouseX = 0;
	let mouseY = 0;
	let ticking = false;
	const interactiveSelector =
		"a, button, [role='button'], input[type='submit'], input[type='button']";

	document.addEventListener("mousemove", (e) => {
		mouseX = e.clientX;
		mouseY = e.clientY;

		// requestAnimationFrame evita que el navegador se sature al mover el mouse
		if (!ticking) {
			window.requestAnimationFrame(() => {
				cursor.style.left = `${mouseX}px`;
				cursor.style.top = `${mouseY}px`;
				ticking = false;
			});
			ticking = true;
		}
	});

	// Optimización de hovers usando selectores agrupados
	document.addEventListener("mouseover", (e) => {
		if (e.target.closest(interactiveSelector)) {
			cursor.classList.add("hover");
		}
	});

	document.addEventListener("mouseout", (e) => {
		if (e.target.closest(interactiveSelector)) {
			cursor.classList.remove("hover");
		}
	});
};

export { customCursor };
